import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"26rem","max-width":"90vw"},
  class: "px-6 pt-5 pb-6"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "text-20px text-center font-semibold text-black-lp-300 mt-1" }
const _hoisted_5 = { class: "text-14px text-center text-gray-lp-500 mt-1" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = {
  class: "text-12px text-gray-lp-500 text-right mb-6",
  "data-testid": "pickup-cancel-confirm-char-counter"
}
const _hoisted_8 = { class: "flex items-center flex-row gap-x-4 w-full mx-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.isOpen,
    persistent: true,
    header: false,
    customBody: "p-0",
    "data-testid": "pickup-cancel-confirm-modal"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/badge-confirmation-general.svg`),
              alt: "illustration-confirmation",
              class: "w-32 h-32"
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("pickup.cancel.confirm.title")), 1),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("pickup.cancel.confirm.instruction")), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_LpInput, {
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.reason = $event)),
            type: "textarea",
            "data-testid": "pickup-cancel-confirm-reason-input",
            placeholder: _ctx.$t('pickup.cancel.confirm.reasonPlaceholder'),
            maxLength: 255
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("pickup.cancel.confirm.charCounter", {
            current: _ctx.reason.length,
            max: 255
          })), 1),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_LpButton, {
            "data-testid": "pickup-cancel-confirm-button-back",
            outline: "",
            textColor: "red-lp-100",
            customClass: "px-8",
            title: _ctx.$t('pickup.cancel.confirm.back'),
            isWidthFull: true,
            disabled: _ctx.isLoading,
            onClick: _ctx.onCancel
          }, null, 8, ["title", "disabled", "onClick"]),
          _createVNode(_component_LpButton, {
            "data-testid": "pickup-cancel-confirm-button-continue",
            textColor: "white",
            customClass: "px-8",
            title: _ctx.$t('pickup.cancel.confirm.continue'),
            disabled: !_ctx.isReasonValid || _ctx.isLoading,
            isWidthFull: true,
            onClick: _ctx.onConfirm
          }, null, 8, ["title", "disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}